import { IFeedback, IFeedbackFetch } from 'src/models/IHost';

export enum ReviewActionEnum {
  CLEAR_REVIEW_RESULT = 'CLEAR_REVIEW_RESULT',

  REQUEST_ADD_REVIEW = 'REQUEST_ADD_REVIEW',
  RESULT_ADD_REVIEW = 'RESULT_ADD_REVIEW',

  REQUEST_UPDATE_REVIEW = 'REQUEST_UPDATE_REVIEW',
  RESULT_UPDATE_REVIEW = 'RESULT_UPDATE_REVIEW',

  REQUEST_DELETE_REVIEW = 'REQUEST_DELETE_REVIEW',
  RESULT_DELETE_REVIEW = 'RESULT_DELETE_REVIEW'
}

export interface ReviewState {
  isLoading: {
    update: boolean;
    add: boolean;
    delete: boolean;
  };
  result: {
    update?: number | string;
    add?: number | string;
    delete?: number | string;
  };
}

export interface ClearReviewResultAction {
  type: ReviewActionEnum.CLEAR_REVIEW_RESULT;
}

export interface AddReviewAction {
  type: ReviewActionEnum.REQUEST_ADD_REVIEW;
  data: IFeedback;
}
export interface ResultAddReviewAction {
  type: ReviewActionEnum.RESULT_ADD_REVIEW;
  status: number;
}

export interface UpdateReviewAction {
  type: ReviewActionEnum.REQUEST_UPDATE_REVIEW;
  currentReview: IFeedbackFetch;
  id: string | number;
}
export interface ResultUpdateReviewAction {
  type: ReviewActionEnum.RESULT_UPDATE_REVIEW;
  status: number;
}

export interface DeleteReviewAction {
  type: ReviewActionEnum.REQUEST_DELETE_REVIEW;
  id: number;
}
export interface ResultDeleteReviewAction {
  type: ReviewActionEnum.RESULT_DELETE_REVIEW;
  status: number;
}

export type ReviewAction =
  | AddReviewAction
  | ResultAddReviewAction
  | UpdateReviewAction
  | ResultUpdateReviewAction
  | DeleteReviewAction
  | ResultDeleteReviewAction
  | ClearReviewResultAction
  | AddReviewAction
  | ResultAddReviewAction
  | UpdateReviewAction
  | ResultUpdateReviewAction
  | DeleteReviewAction
  | ResultDeleteReviewAction;
